<template>
  <div>
    <section class="cost-section payable now">
      <table>
        <tbody>
          <tr>
            <td>
              <translate tag="strong"> Payable now </translate>
            </td>
            <td>
              <pu-price :price="deposit" :display-original-price="true" />
            </td>
          </tr>
          <tr class="info">
            <td colspan="2">
              <p>
                <translate>
                  Pitchup.com will bill you the deposit now.
                </translate>
                <translate :tt="{ depositPercent }">
                  This is a {depositPercent, number, percent} non-refundable
                  deposit.
                </translate>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </section>

    <section class="cost-section payable later">
      <table>
        <tbody>
          <tr>
            <td>
              <translate tag="strong"> Balance </translate>
            </td>
            <td>
              <pu-price :price="remainder" :display-original-price="true" />
            </td>
          </tr>
          <tr class="info">
            <td colspan="2">
              <translate tag="p" :tt="{ campsiteName, balanceDueDate }">
                {campsiteName} will debit your card on {balanceDueDate, puDate,
                full}.
              </translate>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { MoneyType as Money } from '~/utility/money'

@Component
class BookingPaymentDeferred extends Vue {
  @Prop()
  depositPercent: number

  @Prop()
  campsiteName: string

  @Prop()
  balanceDueDate: string

  @Prop()
  deposit: Money

  @Prop()
  remainder: Money
}

export default toNative(BookingPaymentDeferred)
</script>
<style scoped>
.refund-until {
  margin-top: 0.5em;
}
</style>
